import { createSlice } from "@reduxjs/toolkit";
import {
  fetchClientParams,
  saveClientParam,
  deleteClientParam,
} from "@/apis/config/clientParamsApi";

const initialState = {
  list: [],
  current: null,
  listLoading: false,
  currentLoading: false,
  saving: false,
  deleting: false,
};

const slice = createSlice({
  name: "clientParams",
  initialState,
  reducers: {
    clearCurrentParam(state) {
      state.current = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchAll
      .addCase(fetchClientParams.pending, (s) => { s.listLoading = true })
      .addCase(fetchClientParams.fulfilled, (s, a) => { s.list = a.payload; s.listLoading = false })
      .addCase(fetchClientParams.rejected, (s) => { s.listLoading = false })

      // save (create/update)
      .addCase(saveClientParam.pending, (s) => { s.saving = true })
      .addCase(saveClientParam.fulfilled, (s, a) => {
        const idx = s.list.findIndex(p => p.clientParamID === a.payload.clientParamID);
        if (idx >= 0) s.list[idx] = a.payload;
        else s.list.push(a.payload);
        s.current = a.payload;
        s.saving = false;
      })
      .addCase(saveClientParam.rejected, (s) => { s.saving = false })

      // delete
      .addCase(deleteClientParam.pending, (s) => { s.deleting = true })
      .addCase(deleteClientParam.fulfilled, (s, a) => {
        s.list = s.list.filter(p => p.clientParamID !== a.payload);
        if (s.current?.clientParamID === a.payload) s.current = null;
        s.deleting = false;
      })
      .addCase(deleteClientParam.rejected, (s) => { s.deleting = false });
  },
});

export const { clearCurrentParam } = slice.actions;
export default slice.reducer;
